import StaticStickitView from './static_stickit_view';

export default StaticStickitView.extend({
  initialize(options) {
    StaticStickitView.prototype.initialize.apply(this, options);
    this.availabilityCache = new Backbone.Model({
      'overnight-boarding': false,
      'overnight-traveling': false,
      'doggy-day-care': true,
    });

    const self = this;
    this.$('.js-fulltime-availability').on('change', event => {
      self.model.set('fulltime_availability', $(event.target).prop('checked'));
    });

    this.listenTo(this.model, 'change:service_type', _.bind(this.setAvailabilityToLastValue, this));
    this.listenTo(this.model, 'change:service_type', _.bind(this.updateVisibility, this));
    this.listenTo(
      this.model,
      'change:fulltime_availability',
      _.bind(this.updateAvailabilityForServiceType, this)
    );
    this.updateVisibility(this.model, this.model.get('service_type'));
  },
  render() {
    StaticStickitView.prototype.render.apply(this);
    this.$el.removeClass('hidden');
  },
  updateVisibility(model, serviceType) {
    const shouldBeVisible = this.calculateVisibility(serviceType);
    if (shouldBeVisible) {
      this.$el.removeClass('hidden');
    } else {
      this.$el.addClass('hidden');
    }
  },
  calculateVisibility(serviceType) {
    // Currently we only show this filter for doggy-day-care searches
    return serviceType === 'doggy-day-care';
  },
  setAvailabilityToLastValue(model, serviceType) {
    this.model.set('fulltime_availability', this.availabilityCache.get(serviceType));
  },
  updateAvailabilityForServiceType(model, value) {
    this.availabilityCache.set(this.model.get('service_type'), value);
    this.$('.js-fulltime-availability').prop('checked', value);
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/fulltime_availability_selection_view.js